export enum CustomerUsersTabsEnum {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
  REGISTERED = 'REGISTERED',
  CREATED = 'CREATED',
  FORMER = 'FORMER',
}
